import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AttachSession } from 'protractor/built/driverProviders';
import { finalize } from 'rxjs/operators';
import { PartnerService } from 'src/app/partner/partner.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../core/authentication/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private authService: AuthService, private spinner: NgxSpinnerService,
    private router: Router, private route: ActivatedRoute, private service: PartnerService) { }

  title = 'Login';
  isTecalis = false;
  checkingUpdate: boolean = false;
  qrcode: any;
  login() {
    this.spinner.show();
    this.authService.login();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if(params['passwordchanged'] == 'true'){
        this.authService.login();
      }
      if (this.authService.isAuthenticated()) {
        this.qrcode = environment.spaUrl + "/login?idpartneruser=" + this.authService.sub + "&idpartner=" + this.authService.idpartner + "&verificationcode=6e9dd38c-1a52-4c0f-9089-59ef4c16bb70";
        //if(this.authService.EmployeeId != 'MPAAgent' && this.authService.EmployeeId != 'D2DAgent')
        if(this.authService.status == 0 || this.authService.status == 1 || this.authService.status == 2){
          if(this.authService.idpartner != ""){
            this.service.CheckPartnerStatus(this.authService.authorizationHeaderValue, this.authService.idpartner)
            .subscribe(
              (result: any) => {
                this.authService.status = result;
                switch (result) {
                  case 1:
                    this.router.navigate(['/partner/register']);
                    break;
                  case 2:
                    this.router.navigate(['/partner/sign']);
                    break;
                  case 3:
                  case 4:
                  case 6:
                  case 7:
                     //this.router.navigate(['/partner']);
                    break;
                  default:
                    break;
                }
              });
          }
        }
      } else {
        if (params['verificationcode'] != undefined && params['verificationcode'] == '6e9dd38c-1a52-4c0f-9089-59ef4c16bb70') {
          this.router.navigate(['/lead/newnoauth'], { queryParams: { IdPartnerUser: params['idpartneruser'], IdPartner: params['idpartner'] } })
        }
      }
    })
  }

  newLead(){
    this.router.navigate(['/lead/new']);
  }

  listLead(){
    this.router.navigate(['/lead']);
  }
}


